import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import AccordionSection from '../AccordionSection';
import CopyButton from '../CopyButton';
import { formatConversationHistoryForCopy } from '../utils';
import { ConversationHistoryRenderer, LastMessagePreview } from './ConversationHistoryRenderer';

/**
 * Conversation history display component
 */
const ConversationHistory = ({ 
  history, 
  respondedToIndex, 
  expanded, 
  onToggle,
}) => {
  const copyText = useMemo(() => {
    const content = formatConversationHistoryForCopy(history, respondedToIndex);
    return `=== CONVERSATION HISTORY ===\n\n${content}`;
  }, [history, respondedToIndex]);

  if (!history || !Array.isArray(history) || history.length === 0) {
    return null;
  }

  return (
    <div className="relative">
      <AccordionSection
        title="Conversation History"
        defaultExpanded={false}
        colorTheme="blue"
        previewComponent={<LastMessagePreview history={history} respondedToIndex={respondedToIndex} />}
        expanded={expanded}
        onToggle={onToggle}
      >
        <div className="max-h-96 overflow-y-auto">
          <ConversationHistoryRenderer history={history} respondedToIndex={respondedToIndex} />
        </div>
      </AccordionSection>
      <CopyButton
        onCopy={copyText}
        ariaLabel="Copy conversation history"
        title="Copy conversation history"
        colorTheme="blue"
      />
    </div>
  );
};

ConversationHistory.propTypes = {
  history: PropTypes.array,
  respondedToIndex: PropTypes.number,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default React.memo(ConversationHistory);

